export default __webpack_public_path__ + "static/media/8539.a6fed714.jpg";